import { withErrorHandler } from '@/decorators/errorHandler';

export function applyErrorHandlers(controllerClass) {
  Object.getOwnPropertyNames(controllerClass)
    .filter(prop => typeof controllerClass[prop] === 'function')
    // Skip _-prefixed private helpers: wrapping makes them async, so an un-awaited
    // internal call (e.g. this._validateId) silently no-ops its guard. Private
    // helpers must stay synchronous. (#51)
    .filter(methodName => !methodName.startsWith('_'))
    .forEach(methodName => {
      // Wrap each public static method with the error handler.
      controllerClass[methodName] = withErrorHandler(controllerClass[methodName]);
    });
}
